export default "__VITE_ASSET__f1fa2946__"